
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class IconCircle extends Vue {
  @Prop({ default: '' }) readonly icon!: string;
  @Prop({ default: '' }) readonly link!: string;
  @Prop({ default: '' }) readonly tooltip!: string;
  @Prop({ default: 0 }) readonly index!: number;
  @Prop({ default: 1 }) readonly total!: number;
  @Prop({ default: 130 }) readonly radius!: number;
  @Prop({ default: false }) readonly isMobile!: boolean

  hover = false

  get circleStyle () {
    const angle = (360 / this.total) * this.index
    const rad = (Math.PI / 180) * angle
    const x = this.radius * Math.cos(rad)
    const y = this.radius * Math.sin(rad)

    return {
      position: 'absolute',
      left: this.isMobile ? '44%' : '45%',
      top: this.isMobile ? '40%' : '45%',
      transform: `translate(${x}px, ${y}px)`,
    }
  }

  redirect (link: string) {
    this.$router.push({ name: 'help', query: { tab: link } }).catch(() => {
    })
  }
  }
